// extracted by mini-css-extract-plugin
export var faq = "joinus-module--faq--izrlV";
export var q = "joinus-module--q--2YT+o";
export var a = "joinus-module--a--WiBq-";